import * as Yup from 'yup';

import { StepType, StepValidationMap } from './types';
import { State } from './store';

export const contactDataSchema = Yup.object().shape({
  name: Yup.string().required('Name is required').max(110, 'Name must be at most 110 characters'),
  email: Yup.string().required('Email is required').email('Email is invalid'),
  phone: Yup.string().matches(/^\d*$/, 'Please enter only digits for phone').matches(/.{8,}/, {
    excludeEmptyString: true,
    message: 'Phone number should have at least 8 digits',
  }),
  message: Yup.string().required('Message is required').max(1000, 'Message must be at most 1000 characters'),
});

export const detailsSchema = Yup.object().shape({
  email: Yup.string().required('Email is required').email('Email is invalid'),
  confirmEmail: Yup.string()
    .required('Confirm Email required')
    .email('Confirm Email is invalid')
    .oneOf([Yup.ref('email'), null], 'Emails must match'),
  firstName: Yup.string().required('First Name is required').max(55, 'First Name must be at most 55 characters'),
  lastName: Yup.string().required('Last Name is required').max(55, 'Last Name must be at most 55 characters'),
  postalCode: Yup.string()
    .required('Post Code is required')
    .min(7, 'Post Code should be at least 7 characters')
    .max(8, 'Post Code should be at most 8 characters'),
  addressLine1: Yup.string()
    .required('Address Line 1 is required')
    .max(100, 'Address Line 1 must be at most 100 characters'),
  addressLine2: Yup.string().max(100, 'Address Line 2 must be at most 100 characters'),
  country: Yup.string().required('Country is required'),
  county: Yup.string().required('County is required'),
  city: Yup.string().required('City is required').max(55, 'Address Line 2 must be at most 55 characters'),
  iban: Yup.string()
    .required('Account IBAN is required')
    .min(15, 'Account IBAN should be at least 15 and at most 32 characters.')
    .max(32, 'Account IBAN should be at least 15 and at most 32 characters.'),
  isTermsConfirmed: Yup.boolean().required('Must be accepted').oneOf([true], 'Must be accepted'),
});

const brandAndModelSchema = {
  brand: Yup.string().required('Vendor is required'),
  model: Yup.string(),
};

const imeiSchema = {
  imei: Yup.string()
    .required('IMEI is required')
    .matches(/^\d+$/, 'Please enter only digits for IMEI')
    .min(15, 'IMEI should be 15 digits long')
    .max(15, 'IMEI should be 15 digits long'),
};

export const newDeviceCheckSchema = Yup.object().shape({
  ...imeiSchema,
  retailer: Yup.string(),
  retailerOther: Yup.string(), // TODO: Should be required in case retailer is "Other"
  purchaseDate: Yup.number().required('Purchase date is required'),
  purchaseConfirmation: Yup.string().required('Purchase confirmation file is required'),
});

export const oldDeviceModelSchema = Yup.object().shape({
  ...brandAndModelSchema,
});

export const oldDeviceStatusSchema = Yup.object().shape({
  imeiOld: Yup.string()
    .max(15, 'IMEI should be 15 symbols long')
    .min(15, 'IMEI should be 15 symbols long')
    .required('The imei is required'),
  isVendorUnlocked: Yup.boolean(),
  isFactoryResetDone: Yup.boolean(),
  isDeviceWorking: Yup.boolean(),
});

export const stepValidationMap: StepValidationMap<Yup.BaseSchema> = {
  [StepType.NewDeviceCheck]: newDeviceCheckSchema,
  [StepType.OldDeviceModel]: oldDeviceModelSchema,
  [StepType.OldDeviceStatus]: oldDeviceStatusSchema,
  [StepType.Details]: detailsSchema,
} as unknown as Record<Partial<StepType>, Yup.BaseSchema>;

export function validateStep(step: keyof StepValidationMap, data: Partial<State>): boolean {
  try {
    stepValidationMap[step].validateSync(data);
    return true;
  } catch (err) {
    // console.info(`${step} error - ${err}`)
    return false;
  }
}
